import React from 'react';

function Header() {
    return (
    <header>
    <h1>Astrologo y Vidente en Estados Unidos   |   Astrologer and Clairvoyand in the United States</h1>
    <p>Te ayudo a encontrar claridad y propósito a través de la Astrología y la espiritualidad.
    I help you find clarity and purpose through astrology and spirituality.
    </p>
        <nav>
        <a href="#inicio">Inicio/Home</a>
        <a href="#servicios">Servicios/Servicies</a>
        <a href="#testimonios">Testimonios/Testimonials</a>
        <a href="#contacto">Contacto/Contact</a>
        </nav>
    </header>
    );
}

export default Header;